import { QueryClient } from "@tanstack/react-query";

import { captureException } from "lib/logger";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
    mutations: {
      onError: (err: Error) => {
        captureException(err);
      },
    },
  },
});

queryClient.getQueryCache().config.onError = (err: Error, query) => {
  captureException(err, { extra: { key: query.queryKey } });
};
